import { useInfiniteQuery } from "@tanstack/react-query";
import { Conversation } from "@42maru/webchat";
import { emptyPage, MessageHistorySearchType } from "@/model";
import conversationRepository from "@/repository/conversationRepository";


interface UsePaginatedConversationsProps {
    scenarioId: string;
    startDate: string;
    endDate: string;
    searchType: MessageHistorySearchType;
    searchKeyword?: string;
    size: number;
}

interface PageParam {
    page: number;
    size: number;
}

const getData = async (
    scenarioId: string, 
    { page, size }: PageParam, 
    startDate: string, 
    endDate: string, 
    searchType: MessageHistorySearchType, 
    searchKeyword?: string
) => {
    const res = await conversationRepository.find(scenarioId, startDate, endDate, searchType, searchKeyword, page, size);
    return res.data || emptyPage<Conversation>();
};

export const usePaginatedConversations = ({
    scenarioId,
    startDate,
    endDate,
    searchType,
    searchKeyword,
    size
}: UsePaginatedConversationsProps) => {
    const initialPageParam: PageParam = {
        page: 0,
        size: size
    };

    return useInfiniteQuery({
        queryKey: ["conversations", "paginated", scenarioId, initialPageParam.page, initialPageParam.size, startDate, endDate, searchType, searchKeyword],
        queryFn: ({ pageParam = initialPageParam }) => getData(scenarioId, pageParam, startDate, endDate, searchType, searchKeyword),
        initialPageParam,
        getNextPageParam: (lastPage) => {
            if (!lastPage?.has_next) {
                return undefined;
            }
            return {
                page: lastPage.page + 1,
                size: lastPage.size
            };
        }
    });
};
